import { FileFindIcon } from './FileFindIcon';

/**
 * author: Google
 * id A9D2E13D-A9F6-48AC-9998-22756DA6C709
 * name file-find
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-find.svg
 * tags
 * - Files / Folders 
 */
export const PrintPreviewIcon = FileFindIcon;
export default PrintPreviewIcon